import React, { useState, useEffect } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Alert, Button, Drawer, DrawerHeader, DrawerBody, DrawerFooter, LoadingButton, TextField, Link, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useExperienceContext } from '../../../hooks/useContexts';
import { SubmitEditPickupPersonRequest, } from '../../../api/oms/edit-pickup-person';
import { getCookieValue } from '../../../utils/cookie-helper';
import { getWindow } from '../../../utils/general';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { renderStatusMessage } from '../util/general';
import '../../../styles/drawer.scss';
var regex = /^[a-zA-Z0-9/., -]+$/;
var submitEditPickupPerson = function (requestData, setOpen, setPickupPersonState, setPickupPersonFraudError, setIsLoading, setShowSurvey, setNameError, firstNameValue, lastNameValue, traceId) {
    if (firstNameValue === '' ||
        !regex.test(firstNameValue) ||
        firstNameValue.length >= 40 ||
        lastNameValue === '' ||
        !regex.test(lastNameValue) ||
        lastNameValue.length >= 60) {
        setNameError(true);
        return;
    }
    setIsLoading(true);
    SubmitEditPickupPersonRequest(requestData, setOpen, setPickupPersonState, setPickupPersonFraudError, setIsLoading, setShowSurvey, traceId);
};
export var EditPickupPersonDrawer = function (_a) {
    var _b;
    var open = _a.open, setOpen = _a.setOpen, setPickupPersonState = _a.setPickupPersonState, setPickupPersonFraudError = _a.setPickupPersonFraudError, fulfillmentGroup = _a.fulfillmentGroup, orderId = _a.orderId, fulfillmentType = _a.fulfillmentType, orderDetailsData = _a.orderDetailsData, customerType = _a.customerType;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _c = useState(''), firstNameValue = _c[0], setFirstName = _c[1];
    var _d = useState(''), lastNameValue = _d[0], setLastName = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), showSurvery = _f[0], setShowSurvey = _f[1];
    var _g = useState(true), alertState = _g[0], setAlertState = _g[1];
    var _h = useState(false), nameError = _h[0], setNameError = _h[1];
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var traceId = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId;
    var closeDrawer = function (reload) {
        var _a, _b;
        setOpen(false);
        setIsLoading(false);
        if (reload) {
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
    };
    var renderSurvey = function () {
        var _a, _b;
        return (React.createElement("div", null,
            React.createElement("input", { type: "hidden", id: "orderNumberForEditPickup", value: orderId }),
            React.createElement("input", { type: "hidden", id: "orderOriginForEditPickup", value: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin }),
            React.createElement("input", { type: "hidden", id: "storeNumberForEditPickup", value: (_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number }),
            React.createElement("input", { type: "hidden", id: "salesDateForEditPickup", value: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate }),
            React.createElement("input", { type: "hidden", id: "fulfillmentTypeForEditPickup", value: fulfillmentType }),
            React.createElement("input", { type: "hidden", id: "customerTypeForEditPickup", value: customerType }),
            React.createElement("div", { id: "editpickuppersonXPsurvey", style: {
                    display: 'block',
                } })));
    };
    useEffect(function () {
        if (showSurvery) {
            setTimeout(function () {
                var _a, _b, _c, _d;
                if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                    (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.load();
                    (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.run();
                }
            }, 100);
        }
    });
    var submitPickupPerson = function () {
        var _a, _b, _c, _d;
        var requestData = {
            orderId: orderId,
            fulfillmentType: (fulfillmentType &&
                ((_a = convertedFulfillmentTypes(fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase())) ||
                undefined,
            storeNumber: (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _b === void 0 ? void 0 : _b.store) === null || _c === void 0 ? void 0 : _c.number,
            pickupPersonFirstName: firstNameValue,
            pickupPersonLastName: lastNameValue,
            hdWillCallNumber: (_d = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _d === void 0 ? void 0 : _d.hdWillCallNumber,
            forterToken: getCookieValue('forterToken') || undefined,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
        };
        submitEditPickupPerson(requestData, setOpen, setPickupPersonState, setPickupPersonFraudError, setIsLoading, setShowSurvey, setNameError, firstNameValue, lastNameValue, traceId);
    };
    return (React.createElement(Drawer, { open: open, onClose: function () { return (showSurvery ? closeDrawer('reload') : closeDrawer()); }, position: "right", height: "100%" },
        React.createElement(DrawerHeader, { title: "Edit Pickup Person", onClose: function () { return (showSurvery ? closeDrawer('reload') : closeDrawer()); } }),
        showSurvery ? (React.createElement(React.Fragment, null,
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: "sui-p-4" }, alertState ? (React.createElement(Alert, { status: "success", onClose: function () {
                        setAlertState(false);
                    } }, "Your pickup person has been updated. Please notify your new pickup person when this order is ready for pickup.")) : undefined),
                React.createElement(ErrorBoundary, { name: "edit-pickup-survey" }, renderSurvey())),
            React.createElement(DrawerFooter, { className: "sui-bottom-auto sui-p-4" },
                React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "primary", style: { width: '100%' }, onClick: function () { return closeDrawer('reload'); } }, "Close"))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-text-right sui-pr-5 sui-pt-4" },
                React.createElement(Link, { component: "button", onClick: function () {
                        setFirstName('');
                        setLastName('');
                    } }, "Clear All")),
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: "sui-pb-6" },
                    React.createElement(TextField, { id: "export-order-details-csv", label: "First Name *", value: firstNameValue, onChange: function (event) {
                            setFirstName(event.target.value);
                        }, fullWidth: true, statusMessage: nameError && renderStatusMessage('first', firstNameValue), status: (firstNameValue === '' ||
                            firstNameValue.length >= 40 ||
                            !regex.test(firstNameValue)) &&
                            nameError === true
                            ? 'error'
                            : undefined })),
                React.createElement("div", null,
                    React.createElement(TextField, { id: "export-order-details-csv", label: "Last Name *", value: lastNameValue, onChange: function (event) {
                            setLastName(event.target.value);
                        }, fullWidth: true, statusMessage: nameError && renderStatusMessage('last', lastNameValue), status: (lastNameValue === '' ||
                            lastNameValue.length >= 60 ||
                            !regex.test(lastNameValue)) &&
                            nameError === true
                            ? 'error'
                            : undefined }))),
            React.createElement(DrawerFooter, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-2 sui-mt-8" },
                    React.createElement("div", { className: "sui-mb-2" },
                        React.createElement(LoadingButton, { style: { width: '100%' }, loading: isLoading, onClick: function () { return submitPickupPerson(); } }, "Save Changes")),
                    React.createElement("div", { className: classNames('card-fix', {
                            'ios-bottom-fix': isIosMobile,
                        }) },
                        React.createElement(Button, { variant: "secondary", style: { width: '100%' }, onClick: function () { return closeDrawer(); } }, "Close"))))))));
};
